<div
  appInviewPort
  class="mt-4 w-10/12 mx-auto p-8 grid grid-cols-1 lg:grid-cols-5 md:grid-cols-3 items-center opacity-0 transition-all duration-500 ease-in-out">
  <div
    [ngClass]="{
    'scale-[0.95] col-span-3': activeAwareness,
    'scale-100 col-span-1 lg:col-span-2 md:col-span-2': !activeAwareness
  }"
    class=" flex flex-col awareness transition-all duration-1000 ease-linear">
    <div class="font-bold text-4xl text-primary intro-y">
      {{ portalAwareness?.title }}
    </div>
    <div class="font-normal text-gray-400 text-md mt-2 intro-y">
      @if (!activeAwareness) {
        {{ portalAwareness?.description |ellipsis:ellipticalValue }}
      } @else {
        {{ portalAwareness?.description }}
      }

      @if (portalAwareness?.isVideo) {
        <app-video-player
          [autoplay]="false"
          [videoURL]="environment.AUTH_SERVER_URL+'/'+portalAwareness?.videoUrl"
          [videoType]="VideoTypeChoices.LOCAL_MACHINE"
          [videoTitle]="portalAwareness?.title">
        </app-video-player>
      }


      @if (activeAwareness) {
        <button (click)="readMore()" class="!rounded-full px-4 py-2 !bg-secondary !text-white m-2" mat-flat-button>
          Close
        </button>
      } @else {
        <button (click)="readMore()" *ngIf="portalAwareness?.description?.length>ellipticalValue"
                class="!rounded-full px-4 py-2 !bg-gray-100 !text-primary m-2" mat-flat-button> Read
          more
        </button>
        <button (click)="readMore()" *ngIf="portalAwareness?.isVideo"
                class="!rounded-full px-4 py-2 !bg-gray-100 !text-primary m-2" mat-flat-button>
          <mat-icon>fullscreen</mat-icon>
          Expand screen
        </button>
      }
    </div>

    <div *ngIf="awarenessList?.length>1" class="w-full flex justify-center items-center gap-2 mt-4 intro-y ">
      <button (click)="nextOrPrevAwareness(activeIndex-1)" class="!bg-gray-50 !text-primary !shadow-sm" mat-mini-fab>
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="rounded-full py-2 px-5 border-[1px] border-gray-100">
        {{ activeIndex + 1 }} out of {{ awarenessList?.length }}
      </div>
      <button (click)="nextOrPrevAwareness(activeIndex+1)" class="!bg-gray-50 !text-primary !shadow-sm" mat-mini-fab>
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

  </div>

  <div
    [ngClass]="{
    'scale-100 col-span-2': activeAwareness,
    'scale-[0.95] col-span-1 lg:col-span-3 md:col-span-1': !activeAwareness
  }"
    class="transition-transform duration-1000 ease-linear"
  >

    <div class="w-full grid grid-cols-12">
      <div class="col-span-12 relative">
        <img
          [src]="baseUrl+'/'+activeCarouselImage?.path" alt="" class="w-full rounded-2xl shadow-lg" />

        <div class="absolute bottom-0 rounded-b-2xl bg-gradient-to-b from-primary/0 to-primary border-b border-white text-stroke w-full p-4 pt-12 font-bold text-white text-center">
          {{ activeCarouselImage?.description }}
        </div>
      </div>
    </div>

  </div>

</div>
